import React from 'react';
import PropTypes from 'prop-types';

const Button = (props) => {
  const {
    ariaLabel,
    icon,
    className,
    classNameCustom,
    disabled,
    onClick,
    text,
    textClassName,
  } = props;

  return (
    <button
      aria-label={ariaLabel}
      className={`${className} ${classNameCustom}`}
      disabled={disabled}
      onClick={onClick}
      type="button"
    >
      {icon}
      {text && <span className={textClassName || 'button__text'}>{text}</span>}
    </button>
  );
};

Button.defaultProps = {
  ariaLabel: '',
  className: 'button',
  classNameCustom: '',
  icon: null,
  disabled: false,
  onClick: () => {},
  text: '',
  textClassName: '',
};

Button.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  classNameCustom: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  onClick: PropTypes.func,
  text: PropTypes.string,
  textClassName: PropTypes.string,
};

export default Button;
